import {lazyRegister} from '@/Core/lazyRegister';
import './user-menu.component.css';
import template from './user-menu.component.html';
import {WebshopRootScope} from "@/models";

class UserMenuController {
    static $inject = [
        '$element',
        '$rootScope'
    ];

    constructor(private $element,
                private $rootScope: WebshopRootScope) {
    }

    $onInit(): void {
        this.$element.addClass('user-menu');
    }

    signOut() {
        this.$rootScope.logout();
    }
}

export const UserMenuComponent: ng.IComponentOptions = {
    bindings: {},
    template: template,
    controller: UserMenuController
};

lazyRegister.component('userMenu', UserMenuComponent);